/* OV Store — global.js
   JS mínimo, deferido, sin librerías. Respeta prefers-reduced-motion.
   Módulos: rotador de announcement, nav móvil, acordeón FAQ,
   selector de variantes de PDP, reveal on scroll. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Sale countdown --- */
  /* Convierte una hora "de pared" en una zona horaria nombrada (America/New_York)
     al epoch UTC correcto, resolviendo el offset (incluye DST) con Intl. Así el
     countdown es exacto para cualquier ventana futura sin fijar el offset a mano. */
  function tzOffsetMs(date, timeZone) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    dtf.formatToParts(date).forEach(function (part) { p[part.type] = part.value; });
    var h = p.hour === '24' ? 0 : +p.hour;
    var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, h, +p.minute, +p.second);
    return asUTC - date.getTime();
  }
  function zonedTimeToEpoch(y, mo, d, h, mi, timeZone) {
    var utcGuess = Date.UTC(y, mo - 1, d, h, mi, 0);
    var off = tzOffsetMs(new Date(utcGuess), timeZone);
    var epoch = utcGuess - off;
    var off2 = tzOffsetMs(new Date(epoch), timeZone);
    if (off2 !== off) epoch = utcGuess - off2;
    return epoch;
  }
  function initSaleCountdown() {
    var el = document.querySelector('[data-sale-countdown]');
    if (!el) return;
    if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return; // sin Intl: barra estática, sin cifras
    var y = +el.getAttribute('data-cd-y'), mo = +el.getAttribute('data-cd-mo'), d = +el.getAttribute('data-cd-d');
    var h = +el.getAttribute('data-cd-h'), mi = +el.getAttribute('data-cd-mi');
    var tz = el.getAttribute('data-cd-tz') || 'America/New_York';
    if (!y || !mo || !d) { el.hidden = true; return; }
    var target;
    try { target = zonedTimeToEpoch(y, mo, d, isNaN(h) ? 23 : h, isNaN(mi) ? 59 : mi, tz); }
    catch (e) { return; }
    var elDays = el.querySelector('[data-cd-days]'), elHours = el.querySelector('[data-cd-hours]');
    var elMins = el.querySelector('[data-cd-mins]'), elSecs = el.querySelector('[data-cd-secs]');
    var live = el.querySelector('[data-cd-live]');
    var L = {
      days: el.getAttribute('data-l-days') || 'días',
      hours: el.getAttribute('data-l-hours') || 'horas',
      mins: el.getAttribute('data-l-mins') || 'minutos',
      remaining: el.getAttribute('data-l-remaining') || 'restantes'
    };
    var timer = null, ticks = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.hidden = true;                 // auto-oculta al vencer
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      var s = Math.floor(diff / 1000);
      var days = Math.floor(s / 86400); s -= days * 86400;
      var hours = Math.floor(s / 3600); s -= hours * 3600;
      var mins = Math.floor(s / 60); var secs = s - mins * 60;
      if (elDays) elDays.textContent = pad(days);
      if (elHours) elHours.textContent = pad(hours);
      if (elMins) elMins.textContent = pad(mins);
      if (elSecs) elSecs.textContent = pad(secs);
      if (live && ticks % 60 === 0) {
        live.textContent = days + ' ' + L.days + ', ' + hours + ' ' + L.hours + ', ' + mins + ' ' + L.mins + ' ' + L.remaining + '.';
      }
      ticks++;
    }
    tick();                                // primera pintada síncrona → sin flash de placeholder
    if (el.hidden) return;                 // ya venció: no arranca el intervalo
    timer = setInterval(tick, 1000);       // cifras informativas; sin CSS animado (respeta reduced-motion)
  }

  /* --- Announcement rotator --- */
  function initAnnouncement() {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var msgs = bar.querySelectorAll('[data-ann-msg]');
      var dots = bar.querySelectorAll('[data-ann-dot]');
      if (msgs.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        msgs[i].hidden = true;
        if (dots[i]) dots[i].classList.remove('on');
        i = (i + 1) % msgs.length;
        msgs[i].hidden = false;
        if (dots[i]) dots[i].classList.add('on');
      }, 4500);
    });
  }

  /* --- Mobile nav --- */
  function initMobileNav() {
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!drawer) return;
    function open() { drawer.classList.add('open'); document.body.classList.add('nav-open'); drawer.setAttribute('aria-hidden', 'false'); }
    function close() { drawer.classList.remove('open'); document.body.classList.remove('nav-open'); drawer.setAttribute('aria-hidden', 'true'); }
    document.querySelectorAll('[data-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* --- FAQ accordion --- */
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (item) {
      var head = item.querySelector('[data-faq-head]');
      var body = item.querySelector('[data-faq-body]');
      if (!head || !body) return;
      head.setAttribute('aria-expanded', 'false');
      body.hidden = true;
      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.hidden = open;
        var pm = head.querySelector('[data-faq-pm]');
        if (pm) pm.textContent = open ? '+' : '–';
      });
    });
  }

  /* --- PDP variant picker --- */
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var data = root.querySelector('[data-variant-json]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-variant-price]');
      var btnPrice = root.querySelector('[data-btn-price]');
      var barPrice = document.querySelector('[data-buybar-price]');
      var addBtn = root.querySelector('[data-add-btn]');
      var selects = root.querySelectorAll('[data-option-index]');

      function currentOptions() {
        var opts = [];
        selects.forEach(function (group) {
          var checked = group.querySelector('input:checked');
          opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
        });
        return opts;
      }
      function syncPills() {
        // Mueve el resaltado (.on) al pill cuyo radio está marcado; el .on inicial
        // de Liquid queda fijo en el 1er valor y no debe persistir tras cambiar de opción.
        root.querySelectorAll('.buy__pill').forEach(function (pill) {
          var input = pill.querySelector('input[type=radio]');
          if (input) pill.classList.toggle('on', input.checked);
        });
      }
      function update() {
        syncPills();
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        if (btnPrice && match.price_formatted) btnPrice.textContent = '— ' + match.price_formatted;
        if (barPrice && match.price_formatted) barPrice.textContent = match.price_formatted;
        if (addBtn) {
          addBtn.disabled = !match.available;
          if (!match.available && addBtn.getAttribute('data-sold-out')) {
            var lbl = addBtn.querySelector('[data-add-label]');
            if (lbl) lbl.textContent = addBtn.getAttribute('data-sold-out');
          }
        }
      }
      root.querySelectorAll('input[type=radio]').forEach(function (r) { r.addEventListener('change', update); });
      update();
    });
  }

  /* --- Selector de idioma de las landings Complete (snippet lang-picker) ---
     Los radios son el campo `id` de cada formulario de compra. Al elegir en uno, los demás
     selectores de la página marcan la misma variante: la barra fija envía el formulario del hero
     y así respeta la última elección hecha en cualquier punto de la landing. */
  function initLangSync() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-lang-input]') || !t.checked) return;
      document.querySelectorAll('[data-lang-input]').forEach(function (r) {
        if (r !== t && r.value === t.value && !r.disabled) r.checked = true;
      });
    });
  }

  /* --- PDP gallery --- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-gallery-image]') || root.querySelector('.gallery__main img');
      if (!main) return;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (src) { main.src = src; main.removeAttribute('srcset'); }
          root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('on'); });
          thumb.classList.add('on');
        });
      });
    });
  }

  /* --- Reveal on scroll --- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- IFT Pro gate (bundles solo para estudiantes IFT) ---
     Bloquea el add-to-cart si el usuario de IFT Pro está vacío y muestra el mensaje
     aprobado (no el bubble nativo del navegador). Toma el control con novalidate; el
     `required` del HTML queda como red de seguridad si el JS no carga. El listener va en
     el form, así cubre el botón dentro del buy box Y el de la barra sticky móvil (que
     apunta al mismo form vía el atributo form=). */
  function initIftProGate() {
    document.querySelectorAll('[data-ift-pro]').forEach(function (input) {
      var form = input.form;
      if (!form) return;
      form.setAttribute('novalidate', 'novalidate');
      var errEl = form.querySelector('[data-ift-error-msg]');
      var helpId = (input.getAttribute('aria-describedby') || '').split(' ')[0];
      var errId = errEl ? errEl.id : '';
      function clearErr() {
        input.setAttribute('aria-invalid', 'false');
        if (helpId) input.setAttribute('aria-describedby', helpId);
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      }
      function showErr() {
        input.setAttribute('aria-invalid', 'true');
        if (errEl) {
          errEl.textContent = input.getAttribute('data-ift-error') || '';
          errEl.hidden = false;
        }
        if (helpId && errId) input.setAttribute('aria-describedby', helpId + ' ' + errId);
      }
      clearErr();
      input.addEventListener('input', function () { if (input.value.trim() !== '') clearErr(); });
      form.addEventListener('submit', function (e) {
        if (input.value.trim() === '') {
          e.preventDefault();
          showErr();
          input.focus();                     // en móvil arrastra la vista al campo desde la barra sticky
        }
      });
    });
  }

  /* --- Auto-submit selects (collection sort) --- */
  function initAutoSubmit() {
    document.querySelectorAll('[data-auto-submit]').forEach(function (sel) {
      sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
    });
  }

  /* --- Sticky buy bar (PDP móvil + landings Complete) ---
     Aparece al pasar el CTA principal (start) fuera del viewport hacia arriba;
     se oculta al volver al hero. Un id opcional (end) fuerza ocultarla al llegar
     al bloque de compra final. Sin listeners de scroll (IntersectionObserver). */
  function initStickyBar() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-buybar]').forEach(function (bar) {
      var start = document.getElementById(bar.getAttribute('data-buybar-start') || '');
      if (!start) return;
      var endId = bar.getAttribute('data-buybar-end');
      var end = endId ? document.getElementById(endId) : null;
      var pastStart = false, atEnd = false;
      function apply() { bar.classList.toggle('is-visible', pastStart && !atEnd); }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { pastStart = !e.isIntersecting && e.boundingClientRect.top < 0; });
        apply();
      }, { threshold: 0 }).observe(start);
      if (end) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { atEnd = e.isIntersecting; });
          apply();
        }, { threshold: 0 }).observe(end);
      }
    });
  }

  /* --- Glint / spotlight (destellos, doc 10 §4.4) ---
     Barrido especular one-shot sobre precio/dato clave al entrar en viewport. Reutiliza el
     patrón del observer: dispara una vez y deja de observar. Con reduced-motion no dispara
     (el elemento queda en su estado final, destacado por color/peso). Uno por elemento. */
  function initGlint() {
    var els = document.querySelectorAll('[data-glint]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return; // sin motion: nada de barrido
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-glint'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- CTA magnético (doc 10 §4.2) ---
     El CTA primario de compra (.cta-glow) se desplaza hasta 4px hacia el cursor. Solo en
     dispositivos con puntero fino (sin touch), fuera del hilo de scroll (rAF). Escribe en
     las custom props --mx/--my; el CSS combina con el estado :active. Sin cursor o con
     reduced-motion no se activa. */
  function initMagneticCta() {
    if (reduce) return;
    if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches) return;
    var MAX = 4; // px, amplitud baja (institucional, no juguetón)
    document.querySelectorAll('.cta-glow').forEach(function (btn) {
      var raf = null, tx = 0, ty = 0;
      function apply() {
        raf = null;
        btn.style.setProperty('--mx', tx.toFixed(2) + 'px');
        btn.style.setProperty('--my', ty.toFixed(2) + 'px');
      }
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        tx = Math.max(-1, Math.min(1, dx)) * MAX;
        ty = Math.max(-1, Math.min(1, dy)) * MAX;
        if (!raf) raf = requestAnimationFrame(apply);
      });
      btn.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(apply);
      });
    });
  }

  /* --- Barrido especular del CTA de compra (Sprint 6.11 · doc 10 §4.4A) ---
     One-shot al entrar en viewport para captar el ojo (además del :hover/:focus que ya cubre CSS).
     Reutiliza el patrón del observer: dispara una vez, quita la clase al terminar para que el hover
     pueda re-disparar. Con reduced-motion no actúa. No toca botones deshabilitados (sold out). */
  function initCtaShine() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.cta-glow:not([disabled]):not(:disabled)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.classList.add('is-shine');
        el.addEventListener('animationend', function onEnd(ev) {
          if (ev.animationName === 'mo-cta-shine') { el.classList.remove('is-shine'); el.removeEventListener('animationend', onEnd); }
        });
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Conteo animado (count-up) de cifras clave (Sprint 6.11 · doc 10 §4.4) ---
     Anima el entero de 0 → valor final al entrar en viewport, una sola vez. Lee el valor final del
     texto del elemento y PRESERVA su formato (relleno de ceros "01", prefijo/sufijo). No cambia el
     copy: el estado final del DOM es idéntico al render de Liquid. Con reduced-motion queda el valor
     final fijo (sin animar). Uso: <span data-countup>03</span>. */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    els.forEach(function (el) {
      // Lector de pantalla oye el valor final, no el conteo; también guarda el original por si se anima.
      el.setAttribute('aria-label', (el.textContent || '').trim());
    });
    if (reduce || !('IntersectionObserver' in window)) return; // valor final fijo, sin animar
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var raw = (el.getAttribute('aria-label') || el.textContent || '').trim();
        var m = raw.match(/(\D*)(\d[\d.,]*)(\D*)/); if (!m) return;
        var pre = m[1] || '', numStr = m[2], suf = m[3] || '';
        var target = parseInt(numStr.replace(/[.,]/g, ''), 10); if (isNaN(target)) return;
        var pad = numStr.length;
        var dur = Math.min(900, Math.max(360, target * 170)); // más cifra = un pelín más largo
        var t0 = null;
        function fmt(n) { var s = String(n); while (s.length < pad) s = '0' + s; return pre + s + suf; }
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3); // ease-out cúbico
          el.textContent = fmt(Math.round(eased * target));
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = fmt(target); // asienta EXACTO en el valor final
        }
        el.textContent = fmt(0);
        requestAnimationFrame(step);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Expone la altura real del header fijo (countdown + announcement + header) como --stack-h,
  // para que los anclajes (#programas, #guia, …) no queden ocultos bajo la barra. Robusto a
  // countdown presente/ausente y a wrap en móvil. Sin animación → no afecta reduced-motion.
  function initStackHeight() {
    var stack = document.querySelector('.header-stack');
    if (!stack) return;
    function set() {
      var h = Math.round(stack.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--stack-h', h + 'px');
    }
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(stack);
    window.addEventListener('resize', set, { passive: true });
    window.addEventListener('load', set);
  }

  function init() {
    initSaleCountdown();
    initStackHeight();
    initAutoSubmit();
    initAnnouncement();
    initMobileNav();
    initFaq();
    initVariantPicker();
    initLangSync();
    initGallery();
    initReveal();
    initGlint();
    initCountUp();
    initCtaShine();
    initMagneticCta();
    initStickyBar();
    initIftProGate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
